import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const userResetPasswordFn = (data) => apiClient.post(`${APP_SSO_URL}api/user/reset-password`, data);

export const useUserResetPasswordMutation = () => {
  return useMutation({
    mutationFn: userResetPasswordFn,
  });
};
